import { Link } from "react-router-dom/cjs/react-router-dom";
import { Col, Row } from "reactstrap";
import { isUrdu } from "../../../constants/const";
import { GetSelectedLanguage } from "../../helper/Method";


import {
  FcFolder,
  FcOpenedFolder,
} from "react-icons/fc";
/**
 * BreadcrumbNavigation Component
 * Displays folder hierarchy and allows navigation
 */
const BreadcrumbNavigation = ({
  foldersBreadCrumbs,
  onBreadcrumbClick,
  hierarchyDisable,
  deletionInProgress,
  children, // For the buttons component
}) => {
  return (
    <Row>
      <Col md="6">
        <ol className="breadcrumb" style={{ marginTop: 8 }}>
          {foldersBreadCrumbs?.map((item, index) => (
            <li
              className={
                GetSelectedLanguage() === "ur"
                  ? "breadcrumb-item-ur"
                  : "breadcrumb-item"
              }
              key={index}
              onClick={() => {
                if (!hierarchyDisable && !deletionInProgress) {
                  onBreadcrumbClick(item);
                }
              }}
              style={{
                cursor:
                  hierarchyDisable || deletionInProgress ? "default" : "pointer",
              }}
            >
              <Link
                to="#"
                style={{
                  cursor:
                    hierarchyDisable || deletionInProgress
                      ? "default"
                      : "pointer",
                  pointerEvents:
                    hierarchyDisable || deletionInProgress ? "none" : "auto",
                  color:
                    hierarchyDisable || deletionInProgress
                      ? "gray"
                      : "inherit",
                }}
              >
                { index === foldersBreadCrumbs.length - 1 ? (
                  <FcOpenedFolder size={16} />
                ) : (
                  <FcFolder size={16} />
                )}
                &nbsp;
                <span
                  className={isUrdu(item.folderName) ? "ur" : ""}
                  style={{
                    display: "inline-block",
                    fontWeight:
                      foldersBreadCrumbs.length - 1 === index ? 600 : 500,
                    color:
                      foldersBreadCrumbs.length - 1 === index
                        ? "#18A689"
                        : "black",
                  }}
                >
                  {item.folderName}
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </Col>
      {children && <Col md="6">{children}</Col>}
    </Row>
  );
};

export default BreadcrumbNavigation;
